// Copyright (c) Move Closer 2022.

import { AnyObject, Injectable, IResponse, mapCollection, mapModel, ResourceActionFailed } from '@movecloser/front-core'

import { IGraphQL, ProductReviewData, ProductReviewPayload } from '../../../contexts'
import { resolveFromStatus } from '../../../support'

import { IProductReviewsRepository } from '../contracts/repositories'
import { reviewModelConfigAdapter, reviewsAdapterMap } from '../models/reviews.adapter'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Injectable()
export class ReviewsRepository implements IProductReviewsRepository {
  protected graphQlConnector: IGraphQL

  constructor (graphQlConnector: IGraphQL) {
    this.graphQlConnector = graphQlConnector
  }

  public async createProductReview (payload: ProductReviewPayload): Promise<void> {
    // TODO: Remove adapter, add config in Site properties
    const payloadWithConfig: AnyObject = mapModel(payload, reviewModelConfigAdapter)

    const response: IResponse = await this.graphQlConnector.call('createReview', payloadWithConfig)

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    } else if (response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }
  }

  public async loadProductReviews (skus: string[]): Promise<ProductReviewData[]> {
    const response: IResponse = await this.graphQlConnector.call('reviewsQuery', { skus })

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }

    return mapCollection(response.data.productReviews.items, reviewsAdapterMap)
  }
}
